import type { ReactNode } from "react";
import { motion } from "motion/react";

/** Plein écran, contenu centré, aucun scroll — pour les formulaires d'authentification. */
export function CenteredLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex h-dvh items-center justify-center overflow-hidden bg-[#fffdf8] px-6">
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="w-full max-w-sm"
      >
        {children}
      </motion.div>
    </div>
  );
}
